import { render, staticRenderFns } from "./CsrDetailsPageLocked.vue?vue&type=template&id=2c4d69d2&scoped=true&"
import script from "./CsrDetailsPageLocked.vue?vue&type=script&lang=ts&"
export * from "./CsrDetailsPageLocked.vue?vue&type=script&lang=ts&"
import style0 from "./CsrDetailsPageLocked.vue?vue&type=style&index=0&id=2c4d69d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4d69d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
